import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		leaves: [],
		employees: [],
		statics: [],
		remaining: [],
		leavesTypeForEmployee: []
	},
	actions: {
		// GET Requests
		fetchAll ({ commit }, 
			{ employeeIds, month, fromDate, toDate, isDaily, status, leaveTypeId, nonDeleted, perPage, page }) {
			var urlSearchParams = new URLSearchParams();
			var params = { month, fromDate, toDate, isDaily, status, leaveTypeId, nonDeleted, perPage, page }
			Object.keys(params).forEach(param => {
				if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
			});
			employeeIds.forEach(id => {
				urlSearchParams.append('employeeIds', id)
			})
			urlSearchParams.append('nonDeleted', true);
			return window.axios.get('/leaves', { params: urlSearchParams }).then((response) => {
				return {
					data: response.data,
					total: parseInt(response.headers['x-pagination-total-count'])
				}
			}).catch(error => {
				console.error('Error fetching leaves:', error)
			})
		},		  

		fetchById ({ commit }, { id }) {
			return window.axios.get(`/leaves/${id}`).then((data) => { 
				return data 
			}).catch(error => { 
				console.error(`Error fetching leaf with ID ${id}:`, error); 
			});
		},

		fetchStatics ({ commit }) {
			return window.axios.get('leaves/statics').then(({ data }) => {
				commit(types.STORE_LEAVES_STATICS, data);
				return data
			}).catch(error => {
				console.error('Error Fetching Statics', error)
			})
		},

		// fetchUser ({ commit }) {
		// 	return window.axios.get('/users').then(({ data }) => {
		// 		commit(types.STORE_USER, data);
		// 		return data
		// 	}).catch(error => {
		// 		console.error('Error Fetching User', error)
		// 	})
		// },

		fetchRemaining ({ commit }, { userId }) {
			return window.axios.get(`leaves/${userId}/remaining`).then(({ data }) => {
				commit(types.STORE_LEAVES_REMAINING, data);
				return data
			}).catch(error => {
				console.error('Error Fetching Remaining', error)
			})
		},

		fetchLeavesByUserId ({ commit }, { userId, year }) {
			return window.axios.get(`leaves/user/${userId}`, { year }).then(({ data }) => {
				return data
			}).catch(error => {
				console.error('Error Fetching User Leaves', error)
			})
		},

		// POST Requests
		addLeave ({ commit }, { 
			fromDate, toDate, isDaily, durationInDays, durationInMinute, reason, leaveTypeId, status, supervisorAcceptance, supervisorComment, termsAccept, compensable, leaveTaskIds, managerAcceptance, plannedTasksId
		}) {  
			return window.axios.post('/leaves', {
				fromDate, toDate, isDaily, durationInDays, durationInMinute, reason, leaveTypeId, status, supervisorAcceptance, supervisorComment, managerAcceptance, termsAccept, compensable, leaveTaskIds, plannedTasksId
			}).then(({ data }) => {
				return data
			})
		},

		// PUT Requests
		update ({ commit }, { 
			id,
			fromDate, toDate, isDaily, durationInDays, durationInMinute, reason, leaveTypeId, status, supervisorAcceptance, supervisorComment, managerAccept, termsAccept, compensable, leavesTaskId 
		}) {
			return window.axios.put(`/leaves/${id}`, {
				fromDate, toDate, isDaily, durationInDays, durationInMinute, reason, leaveTypeId, status, supervisorAcceptance, supervisorComment, managerAccept, termsAccept, compensable, leavesTaskId
			}).then(({ data }) => {
				return data
			})
		},

		administratorAccept ({ commit }, { id, isAccept }) {
			return window.axios.put(`/leaves/${id}/AdministratorAccept`, isAccept, { headers: { 'Content-Type': 'application/json' } }).then((data) => {
				return data
			})
		},
		
		supervisorAccept ({ commit }, { id, acceptance, comment }) {
			return window.axios.put(`/Leaves/${id}/SupervisorAccept`, { acceptance, comment }).then(({ data }) => {
				return data
			})
		},

		fetchLeavesType ({ commit }) {
			return window.axios.get('/leaves/leaveTypes').then(({ data }) => {
				return data
			})
		},

		fetchLeavesTypeForEmployee ({ commit }, { id }) {
			return window.axios.get(`/Leaves/LeaveTypes/Employee/${id}`).then(({ data }) => {
				commit(types.STORE_LEAVE_TYPE_FOR_EMPLOYEE, data)
				return data
			})
		},
		
		delete ({ commit }, { id }) {
			return window.axios.delete('/Leaves', { params: { id } })
		}
	},
	mutations: {
		[types.STORE_LEAVES_STATICS] (state, statics) { state.statics = statics; },
		[types.STORE_LEAVES_REMAINING] (state, remaining) { state.remaining = remaining; },
		[types.STORE_LEAVE_TYPE_FOR_EMPLOYEE] (state, leavesTypeForEmployee) { state.leavesTypeForEmployee = leavesTypeForEmployee }
	},
	getters: {
		getLeavesById: state => id => state.leaves.find(c => c.id === id),
		getLeaveTypeById: state => id => state.leavesTypeForEmployee.find(c => c.id === id)
	}
}
